<template>
  <table class="tbl">
    <thead>
      <tr>
        <th>작업항목</th><th>작업절차</th><th>위험요인</th><th>재해유형</th>
        <th>현재 안전조치</th><th>위험성</th><th>추가 안전조치</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(p, i) in (procedures || [])" :key="'pr-'+i">
        <td>{{ p.item || '-' }}</td>
        <td>{{ p.procedure || '-' }}</td>
        <td>{{ p.riskFactor || '-' }}</td>
        <td>{{ p.hazard || '-' }}</td>
        <td>{{ p.currentMeasure || '-' }}</td>
        <td>{{ p.riskLevel || '-' }}</td>
        <td>{{ p.additionalMeasure || '-' }}</td>
      </tr>
      <tr v-if="!(procedures || []).length"><td colspan="7" class="text-888">데이터 없음</td></tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PermitProcedureTable',
  props: { procedures: { type: Array, default: () => [] } }
};
</script>